<div class="dhl-overflow-auto">
  <mat-table
    [dataSource]="configuration.request?.isPaginated ? dataSource : dataSourceLocal"
    [ngClass]="{ 'dhl-table-hover': configuration.isClickable }"
    matSort
    matSortActive="created"
    matSortDisableClear
    matSortDirection="desc">
    <!-- DEFINICIÓN DE COLUMNA DE SELECCIÓN -->
    <ng-container *ngIf="configuration.isSelectable" matColumnDef="select">
      <mat-header-cell *matHeaderCellDef class="pt-2">
        <mat-checkbox
          #allCheck
          matTooltip="{{ allCheck.checked ? 'Desmarcar' : 'Seleccionar' }} toda la página"
          (change)="$event ? onSwitchAllPage($event) : null"
          [checked]="selection.hasValue() && onAllPageSelected()">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="pt-2">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? onToSelect(row) : null" [checked]="isSelected(row)"></mat-checkbox>
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>
    <!-- DEFINICIÓN DE COLUMNAS DE OBJETOS -->
    <ng-container *ngFor="let column of configuration.columns">
      <ng-container *ngIf="column.name !== 'select' && column.name !== 'actions' && column.name !== 'toggle'" matColumnDef="{{ column.name }}">
        <mat-header-cell
          *matHeaderCellDef
          [mat-sort-header]="column.isSortable ? column.name : ''"
          [disabled]="!column.isSortable"
          [ngClass]="{
            'dhl-content-left': column.headerAlign === 'left',
            'dhl-content-center': column.headerAlign === 'center',
            'dhl-content-right': column.headerAlign === 'right'
          }">
          {{ column.displayName }}
        </mat-header-cell>
        <ng-container [ngSwitch]="column.type">
          <mat-cell
            #parentElement
            *matCellDef="let row"
            [ngClass]="{
              'dhl-content-left': column.contentAlign === 'left',
              'dhl-content-center': column.contentAlign === 'center',
              'dhl-content-right': column.contentAlign === 'right'
            }"
            [matTooltip]="getColumnTooltip(column, row)"
            [matTooltipDisabled]="!isOverflowing(childElement, parentElement)"
            matTooltipPosition="below"
            matTooltipClass="tooltip">
            <div class="row mobile-only">
              <div class="col-12">
                <span class="mobile-label">{{ column.displayName }}</span>
              </div>
              <div class="col-12">
                <ng-container *ngSwitchCase="gridColumnTypeEnum.Text">
                  {{ row[column.name] }}
                </ng-container>
                <ng-container *ngSwitchCase="gridColumnTypeEnum.DateTime">
                  {{ fnFormatDate(row[column.name]) }}
                </ng-container>
                <ng-container *ngSwitchCase="gridColumnTypeEnum.Currency">
                  {{ row[column.name] }}
                </ng-container>
                <ng-container *ngSwitchCase="gridColumnTypeEnum.HTML">
                  <div [innerHTML]="column.renderHTML?.(row)"></div>
                </ng-container>
                <ng-container *ngSwitchCase="undefined">
                  {{ row[column.name] }}
                </ng-container>
                <ng-container *ngSwitchDefault>
                  {{ row[column.name] }}
                </ng-container>
              </div>
            </div>
            <div class="desktop-only text-truncate" #childElement>
              <ng-container *ngSwitchCase="gridColumnTypeEnum.Text">
                {{ row[column.name] }}
              </ng-container>
              <ng-container *ngSwitchCase="gridColumnTypeEnum.DateTime">
                {{ fnFormatDate(row[column.name]) }}
              </ng-container>
              <ng-container *ngSwitchCase="gridColumnTypeEnum.Currency">
                {{ row[column.name] | currency }}
              </ng-container>
              <ng-container *ngSwitchCase="gridColumnTypeEnum.HTML">
                <div [innerHTML]="column.renderHTML?.(row)"></div>
              </ng-container>
              <ng-container *ngSwitchCase="undefined">
                {{ row[column.name] }}
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{ row[column.name] }}
              </ng-container>
            </div>
          </mat-cell>
        </ng-container>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>
    </ng-container>
    <!-- DEFINICIÓN DE COLUMNA DE ESTATUS -->
    <ng-container *ngIf="configuration.isToggleable" matColumnDef="toggle">
      <mat-header-cell *matHeaderCellDef class="dhl-content-center">Estatus</mat-header-cell>
      <mat-cell *matCellDef="let row" class="dhl-content-center">
        <div class="dhl-table-actions">
          <mat-slide-toggle [checked]="row[configuration.toggleField!]" (click)="onToggle(row)" (change)="onChangeToggle($event, row)" class="dhl-status-slide"> </mat-slide-toggle>
        </div>
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>
    <!-- DEFINICIÓN DE COLUMNA DE ACCIONES -->
    <ng-container *ngIf="configuration.hasActions" matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef class="dhl-content-center">Acciones</mat-header-cell>
      <mat-cell *matCellDef="let row" class="dhl-content-center">
        <div class="dhl-table-actions">
          <div class="row mobile-only">
            <div class="col-12 p-2">
              <span class="mobile-label text-center">Acciones</span>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <ng-template *ngTemplateOutlet="actionsRef; context: { rowData: row }"></ng-template>
            </div>
          </div>
        </div>
      </mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns" (click)="onClickRow(row)"></mat-row>
    <mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></mat-footer-row>
  </mat-table>
</div>
<div class="row" *ngIf="totalRecords === 0 && hasDataAccess">
  <div class="col-lg">
    <div class="empty-state-content">
      <img alt="Vacio" class="empty-state-image" src="./assets/images/common/search-noresults-dhl.svg" />
      <h3 class="empty-state-title">No hay coincidencias</h3>
      <div class="empty-state-body">
        Lo sentimos, no pudimos encontrar ningún resultado que coincida con su búsqueda. Pruebe términos de búsqueda similares o menos específicos o modifique sus filtros.
      </div>
    </div>
  </div>
</div>
<div class="row" *ngIf="!hasDataAccess">
  <div class="col-lg">
    <div class="empty-state-content">
      <img alt="Vacio" class="empty-state-image" src="./assets/images/login/ic_alert.png" />
      <h3 class="empty-state-title">No autorizado</h3>
      <div class="empty-state-body">No tiene permisos para visualizar la información</div>
    </div>
  </div>
</div>
<mat-paginator [length]="totalRecords" [pageSizeOptions]="[10, 20, 30, 40]" [showFirstLastButtons]="true"> </mat-paginator>
